<template>
  <div class="my-biography">
    <v-container>
      <v-row v-if="!$store.state.gallery.open">
        <v-col
          class="text-center"
          cols="12"
        >
          <div class="tw-toggle">
            <input
              id="rdo-personal"
              type="radio"
              name="toggle"
              value="false"
              :checked="content_type === 0"
              @click="checkContentType(0)"
            />
            <label
              for="rdo-personal"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccount}"
                class="mx-auto"
              >
                {{ mdiAccount }}
              </v-icon>
            </label>
            <input
              id="rdo-both"
              type="radio"
              name="toggle"
              value="-1"
              :checked="content_type === -1"
              @click="checkContentType(-1)"
            />
            <label
              for="rdo-both"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountMultiple}"
                class="mx-auto"
              >
                {{ mdiAccountMultiple }}
              </v-icon>
            </label>
            <input
              id="rdo-professional"
              type="radio"
              name="toggle"
              value="true"
              :checked="content_type === 1"
              @click="checkContentType(1)"
            />
            <label
              for="rdo-professional"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountTie}"
                class="mx-auto"
              >
                {{ mdiAccountTie }}
              </v-icon>
            </label>
            <span></span>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!$store.state.gallery.open">
        <div class="d-flex justify-center wrapper-menu">
          <!-- ### Menu Mobile ### -->
          <template v-if="$vuetify.breakpoint.mdAndDown">
            <v-list class="mobile--menu-list">
              <v-list-group
                :value="false"
              >
                <template v-slot:activator>
                  <v-list-item-title>Categories</v-list-item-title>
                </template>

                <template v-if="!content_type || content_type === -1">
                  <div
                    v-for="(item, i) in categories"
                    :key="`system-${i}`"
                  >
                    <v-list-item
                      v-if="!item.children"
                      class="single_item"
                      link
                      @click="searchCategory(item.id, 1)"
                    >
                      <span>-</span> {{ item.name }}
                    </v-list-item>
                    <div v-else>
                      <v-list-group
                        :value="false"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-title @click="searchCategory(item.id, 1)">
                            {{ item.name }}
                          </v-list-item-title>
                        </template>
                        <div
                          v-for="(itemL1) in item.children"
                          :key="`system-L-${itemL1.id}`"
                        >
                          <v-list-item
                            v-if="!itemL1.children"
                            class="single_item"
                            link
                            @click="searchCategory(itemL1.id, 1)"
                          >
                            <span>-</span> {{ itemL1.name }}
                          </v-list-item>
                          <v-list-group
                            v-else
                            :value="false"
                            no-action
                            sub-group
                          >
                            <template v-slot:activator>
                              <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                {{ itemL1.name }}
                              </v-list-item-title>
                            </template>
                            <v-list-item
                              v-for="(itemL2, index) in itemL1.children"
                              :key="`system-L2-${index}`"
                              class="single_item"
                              link
                              @click="searchCategory(itemL2.id, 1)"
                            >
                              <span>-</span> {{ itemL2.name }}
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list-group>
                        </div>
                        <v-divider></v-divider>
                      </v-list-group>
                    </div>
                  </div>
                </template>

                <template v-if="content_type || content_type === -1">
                  <div
                    v-for="(item, i) in professionalCategories"
                    :key="`system-${i}`"
                  >
                    <v-list-item
                      v-if="!item.children"
                      class="single_item"
                      link
                      @click="searchCategory(item.id, 1)"
                    >
                      <span>-</span> {{ item.name }}
                    </v-list-item>
                    <div v-else>
                      <v-list-group
                        :value="false"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-title @click="searchCategory(item.id, 1)">
                            {{ item.name }}
                          </v-list-item-title>
                        </template>
                        <div
                          v-for="(itemL1) in item.children"
                          :key="`system-L-${itemL1.id}`"
                        >
                          <v-list-item
                            v-if="!itemL1.children"
                            class="single_item"
                            link
                            @click="searchCategory(itemL1.id, 1)"
                          >
                            <span>-</span> {{ itemL1.name }}
                          </v-list-item>
                          <v-list-group
                            v-else
                            :value="false"
                            no-action
                            sub-group
                          >
                            <template v-slot:activator>
                              <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                {{ itemL1.name }}
                              </v-list-item-title>
                            </template>
                            <v-list-item
                              v-for="(itemL2, index) in itemL1.children"
                              :key="`system-L2-${index}`"
                              class="single_item"
                              link
                              @click="searchCategory(itemL2.id, 1)"
                            >
                              <span>-</span> {{ itemL2.name }}
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list-group>
                        </div>
                        <v-divider></v-divider>
                      </v-list-group>
                    </div>
                  </div>
                </template>
                <v-divider></v-divider>
                <v-list-item
                  v-if="!content_type"
                  class="single_item"
                  :class="{ 'active': categorySelected === '' }"
                  @click="searchCategory(-1, 1)"
                >
                  - All
                </v-list-item>

                <v-list-item
                  v-if="content_type !== -1"
                  link
                  class="single_item"
                  :class="{ 'active': categorySelected === '' }"
                  @click="$store.commit('showCustomCategories', true);"
                >
                  - Customize
                </v-list-item>
              </v-list-group>
            </v-list>
          </template>

          <div
            v-if="active && !$vuetify.breakpoint.mdAndDown"
            class="inner-wrapper-menu"
          >
            <ul
              v-if="!content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in categories"
                :key="`system-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`system-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`system-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li v-if="!content_type">
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
              <li v-if="content_type !== -1">
                <v-btn
                  elevation="2"
                  @click="$store.commit('showCustomCategories', true);"
                >
                  Customize
                </v-btn>
              </li>
            </ul>

            <ul
              v-if="content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in professionalCategories"
                :key="`system-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`system-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`system-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li v-if="content_type">
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
              <li v-if="content_type !== -1">
                <v-btn
                  elevation="2"
                  @click="$store.commit('showCustomCategories', true);"
                >
                  Customize
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
      </v-row>

      <!-- <v-row>
        <div class="d-flex justify-center wrapper-menu">
          <div class="inner-wrapper-menu">
            <v-btn elevation="2" large>Biography Scroll</v-btn>
            <v-btn elevation="2" large>Biography Tree</v-btn>
            <v-btn elevation="2" large>Biography Connections</v-btn>
            <v-btn elevation="2" large>Biography Book</v-btn>
          </div>
        </div>
      </v-row> -->

      <v-row
        justify="center"
        class="mt-10 mb-6 position-relative"
      >
        <v-container>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="text-subtitle-1 text-center wrapper-content"
              cols="12"
            >
              <div
                v-if="active"
                class="sort-controls mb-4"
              >
                <span class="sort-label">Order by:</span>
                <v-btn-toggle
                  v-model="orderBy"
                  mandatory
                  dense
                  class="sort-field"
                  @change="onSortChange"
                >
                  <v-btn
                    small
                    value="entry_date"
                  >
                    Entry Date
                  </v-btn>
                  <v-btn
                    small
                    value="insert_date"
                  >
                    Insert Date
                  </v-btn>
                </v-btn-toggle>
                <v-btn-toggle
                  v-model="orderDir"
                  class="sort-direction"
                  mandatory
                  dense
                  @change="onSortChange"
                >
                  <v-btn
                    small
                    value="asc"
                    aria-label="Oldest first"
                    title="Oldest first"
                  >
                    <v-icon small>
                      {{ mdiSortAscending }}
                    </v-icon>
                  </v-btn>
                  <v-btn
                    small
                    value="desc"
                    aria-label="Newest first"
                    title="Newest first"
                  >
                    <v-icon small>
                      {{ mdiSortDescending }}
                    </v-icon>
                  </v-btn>
                </v-btn-toggle>
                <div class="date-filter-input-wrapper">
                  <v-icon
                    class="date-filter-lupe"
                    aria-label="Search by date"
                    :color="dateFilter ? 'primary' : ''"
                    @click="toggleDateInput"
                  >
                    {{ mdiMagnify }}
                  </v-icon>
                  <transition name="date-filter-slide">
                    <div
                      v-if="dateInputVisible"
                      class="date-filter-field"
                    >
                      <input
                        ref="dateInput"
                        v-model="dateFilter"
                        type="text"
                        placeholder="____-__-__"
                        aria-label="Date (YYYY-MM-DD)"
                        maxlength="10"
                        class="date-filter-input"
                        :class="{ 'date-filter-input--active': dateFilter }"
                        @input="onDateMaskInput"
                        @keyup.enter="onDateFilterChange"
                        @keyup.esc="closeDateInput"
                        @blur="onDateInputBlur"
                      />
                      <v-icon
                        v-if="dateFilter"
                        small
                        class="date-filter-clear"
                        @mousedown.prevent="clearDateFilter"
                      >
                        {{ mdiClose }}
                      </v-icon>
                    </div>
                  </transition>
                </div>
                <v-menu
                  v-if="active && Object.keys(timeline).length"
                  offset-y
                  :close-on-content-click="false"
                  max-height="360"
                  max-width="300"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="date-menu-button d-lg-none"
                      :title="activeYear ? activeYear + (activeMonth ? ' · ' + months[parseInt(activeMonth, 10) - 1] : '') : 'Filter by date'"
                      outlined
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Date
                      <v-icon
                        right
                        small
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    dense
                    aria-label="Filter biography by date"
                  >
                    <v-list-item @click="dateFilter = ''; searchCategory(-1, 1)">
                      <v-list-item-title>Show All</v-list-item-title>
                    </v-list-item>
                    <v-list-group
                      v-for="year in Object.keys(timeline)"
                      :key="year"
                      :value="year === activeYear"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>
                          {{ year }}
                        </v-list-item-title>
                      </template>
                      <v-list-item
                        :input-value="year === activeYear && !activeMonth"
                        @click="selectTimelineDate(year)"
                      >
                        <v-list-item-title>All of {{ year }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="month in timeline[year]"
                        :key="month"
                        :input-value="year === activeYear && month === activeMonth"
                        @click="selectTimelineDate(year, month)"
                      >
                        <v-list-item-title>{{ months[parseInt(month, 10) - 1] }}</v-list-item-title>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-menu>
              </div>
              <v-timeline v-if="active && files.length">
                <v-timeline-item
                  v-for="(file, i) in files"
                  :key="`biography-${i}`"
                  large
                >
                  <template
                    v-if="!$vuetify.breakpoint.mdAndDown"
                    v-slot:icon
                  >
                    <div class="date-anchor">
                      <div
                        v-if="editingDateIndex === i"
                        class="date-edit-wrapper"
                        @focusout="onDateFocusOut($event, file)"
                      >
                        <select
                          v-model="editDate.month"
                          class="date-edit-input date-edit-month"
                        >
                          <option
                            v-for="(m, mi) in months"
                            :key="mi"
                            :value="mi + 1"
                          >
                            {{ m }}
                          </option>
                        </select>
                        <input
                          v-model.number="editDate.day"
                          type="number"
                          min="1"
                          max="31"
                          class="date-edit-input date-edit-day"
                        />
                        <input
                          v-model.number="editDate.year"
                          type="number"
                          min="1900"
                          max="2999"
                          class="date-edit-input date-edit-year"
                        />
                      </div>
                      <span
                        v-else
                        class="date-item date-item--editable"
                        :title="'Click to edit date'"
                        @click="startEditDate(file, i)"
                      >{{ formatDate(file.updated_at.split('T')[0]) }}</span>
                    </div>
                    <v-icon
                      :class="{'alternate-icon-small': !mdiBookOpenVariant}"
                      class="mx-auto icon-info-date"
                      dark
                    >
                      {{ mdiBookOpenVariant }}
                    </v-icon>

                    <div class="wrapper-icons">
                      <v-icon
                        v-if="!$vuetify.breakpoint.mdAndDown"
                        :class="{'alternate-icon-small': !mdiSquareEditOutline}"
                        class="mx-auto icon-edit"
                        @click="openEdit(file)"
                      >
                        {{ mdiSquareEditOutline }}
                      </v-icon>
                      <v-icon
                        v-if="!deletingFile[i]"
                        :class="{'alternate-icon-small': !mdiTrashCan}"
                        class="mx-auto icon-trash"
                        @click="showDeleteBtns(true, i)"
                      >
                        {{ mdiTrashCan }}
                      </v-icon>
                      <v-icon
                        :class="{'alternate-icon-small': !mdiShareVariantOutline}"
                        class="mx-auto icon-trash"
                      >
                        {{ mdiShareVariantOutline }}
                      </v-icon>
                    </div>
                  </template>
                  <template v-slot:opposite>
                    <div class="v-timeline-item__body box-slider">
                      <v-card
                        class="elevation-2"
                        @click="showModal(file);modals.file.created_at = file.created_at.split('T')[0];"
                      >
                        <div
                          v-if="file.view_type && file.related_files.length > 1"
                          class="biography-media"
                        >
                          <template v-if="isImage(file.related_files[0])">
                            <img
                              :src="`${file.related_files[0]}`"
                              :class="`rotate_images__position_${file.rotate_position[0]}`"
                              @error="onImgError(file.related_files[0])"
                            />
                          </template>
                          <template v-else-if="isVideo(file.related_files[0])">
                            <video
                              width="100%"
                              height="100%"
                              controls
                            >
                              <source
                                :src="file.related_files[0]"
                                :type="getVideoType(file.related_files[0])"
                              >
                              Your browser does not support the video tag.
                            </video>
                          </template>
                        </div>
                        <div
                          v-else
                          class="biography-media"
                        >
                          <!--
                            :cycle="!$store.state.content_type"
                          -->
                          <v-carousel
                            v-if="file.related_files.length > 1"
                            height="100%"
                          >
                            <v-carousel-item
                              v-for="(item, ic) in file.related_files"
                              :key="ic"
                            >
                              <template v-if="isImage(item)">
                                <img
                                  :src="`${item}`"
                                  :class="`rotate_images__position_${file.rotate_position[ic]}`"
                                  @error="onImgError(item)"
                                />
                              </template>
                              <template v-else-if="isVideo(item)">
                                <video
                                  width="100%"
                                  height="100%"
                                  controls
                                >
                                  <source
                                    :src="item"
                                    :type="getVideoType(item)"
                                  >
                                  Your browser does not support the video tag.
                                </video>
                              </template>
                            </v-carousel-item>
                          </v-carousel>
                          <div v-else>
                            <template v-if="isImage(file.related_files[0])">
                              <img
                                :src="`${file.related_files[0]}`"
                                :class="`rotate_images__position_${file.rotate_position[0]}`"
                                @error="onImgError(file.related_files[0])"
                              />
                            </template>
                            <template v-else-if="isVideo(file.related_files[0])">
                              <video
                                width="100%"
                                height="100%"
                                controls
                              >
                                <source
                                  :src="file.related_files[0]"
                                  :type="getVideoType(file.related_files[0])"
                                >
                                Your browser does not support the video tag.
                              </video>
                            </template>
                          </div>
                        </div>

                        <v-card-text
                          v-if="$vuetify.breakpoint.mdAndDown"
                          class="item-description"
                        >
                          <v-container
                            v-if="deletingFile[i]"
                            style="height: 400px;"
                          >
                            <v-row
                              class="fill-height"
                              align-content="center"
                              justify="center"
                            >
                              <v-col
                                v-if="!loading"
                                class="text-subtitle-1 text-center"
                                cols="12"
                              >
                                {{ result ? 'The content has been deleted.' : 'Are you sure you want to delete this content?' }}
                              </v-col>
                              <v-col
                                v-if="!loading && !result"
                                cols="12"
                                class="justify-content-center wrapper-buttons-center"
                              >
                                <v-btn
                                  color="primary"
                                  @click="submitDelete(file.id)"
                                >
                                  Delete
                                </v-btn>
                                <v-btn @click="showDeleteBtns(false, i)">
                                  Cancel
                                </v-btn>
                              </v-col>

                              <v-col
                                v-if="loading"
                                class="text-subtitle-1 text-center"
                                cols="12"
                              >
                                Deleting content...
                              </v-col>
                              <v-col
                                v-if="loading"
                                cols="6"
                              >
                                <v-progress-circular
                                  :size="70"
                                  :width="7"
                                  color="primary"
                                  indeterminate
                                ></v-progress-circular>
                              </v-col>
                            </v-row>
                          </v-container>

                          <div
                            v-if="!deletingFile[i]"
                            class="wrapper-text"
                            @click="showModal(file);modals.file.created_at = file.created_at.split('T')[0];"
                          >
                            <div class="v-card__title">
                              {{ file.name }}
                            </div>
                            <div>
                              <hr
                                role="separator"
                                aria-orientation="horizontal"
                                class="v-divider theme--light"
                              >
                              <div
                                class="v-card__text"
                                v-html="subString(file.alternative_text)"
                              ></div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </template>
                  <v-card
                    v-if="!$vuetify.breakpoint.mdAndDown"
                    class="elevation-2"
                  >
                    <v-card-text class="item-description">
                      <v-container
                        v-if="deletingFile[i]"
                        style="height: 400px;"
                      >
                        <v-row
                          class="fill-height"
                          align-content="center"
                          justify="center"
                        >
                          <v-col
                            v-if="!loading"
                            class="text-subtitle-1 text-center"
                            cols="12"
                          >
                            {{ result ? 'The content has been deleted.' : 'Are you sure you want to delete this content?' }}
                          </v-col>
                          <v-col
                            v-if="!loading && !result"
                            cols="12"
                            class="justify-content-center wrapper-buttons-center"
                          >
                            <v-btn
                              color="primary"
                              @click="submitDelete(file.id)"
                            >
                              Delete
                            </v-btn>
                            <v-btn @click="showDeleteBtns(false, i)">
                              Cancel
                            </v-btn>
                          </v-col>

                          <v-col
                            v-if="loading"
                            class="text-subtitle-1 text-center"
                            cols="12"
                          >
                            Deleting content...
                          </v-col>
                          <v-col
                            v-if="loading"
                            cols="6"
                          >
                            <v-progress-circular
                              :size="70"
                              :width="7"
                              color="primary"
                              indeterminate
                            ></v-progress-circular>
                          </v-col>
                        </v-row>
                      </v-container>

                      <div
                        v-if="!deletingFile[i]"
                        class="wrapper-text"
                        @click="showModal(file);modals.file.created_at = file.created_at.split('T')[0];"
                      >
                        <div class="v-card__title">
                          {{ file.name }}
                        </div>
                        <div>
                          <hr
                            role="separator"
                            aria-orientation="horizontal"
                            class="v-divider theme--light"
                          >
                          <div
                            class="v-card__text"
                            v-html="subString(file.alternative_text)"
                          ></div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
              <!-- <div v-else class="text-subtitle-1 text-center">
                <span v-if="!loading">There are no content to show.</span>

                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="primary"
                  indeterminate
                  v-if="loading"
                ></v-progress-circular>
              </div> -->

              <v-container
                v-if="!files.length"
                style="height: 200px;"
              >
                <v-row
                  class="fill-height"
                  align-content="center"
                  justify="center"
                >
                  <v-col
                    v-if="!loading"
                    class="text-subtitle-1 text-center"
                    cols="12"
                  >
                    There are no content to show.
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </v-container>

              <a
                v-if="active && files.length"
                href="javascript:;"
                class="show-all-years d-none d-lg-block"
                @click="searchCategory(-1, 1);"
              >Show All</a>
              <ul
                v-if="active && files.length"
                class="lst-timeline d-none d-lg-block"
              >
                <li
                  v-for="(year, iy) in Object.keys(timeline)"
                  :key="iy"
                >
                  <a
                    href="javascript:;"
                    :class="{'active': year === activeYear}"
                    @click="getFiles(year);"
                  >
                    {{ year }}
                    <v-icon class="mx-auto">{{ mdiChevronDown }}</v-icon>
                  </a>
                  <ul :class="{'active': year === activeYear}">
                    <li
                      v-for="(month, im) in timeline[year]"
                      :key="im"
                    >
                      <a
                        :class="{'active': month === activeMonth}"
                        href="javascript:;"
                        @click="getFiles(year, month)"
                      >-{{ months[parseInt(month, 10)-1] }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
        <div
          v-if="active && files.length"
          class="pagination"
        >
          <span>{{ this.pagination }} of {{ this.qtdPages }} pages</span>
          <v-btn
            v-if="this.pagination < this.qtdPages"
            color="primary"
            :loading="loading4"
            :disabled="loading4"
            @click="getNextPage()"
          >
            Load more
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>{{ mdiCached }}</v-icon>
              </span>
            </template>
          </v-btn>
        </div>

        <v-btn
          v-if="active && files.length"
          color="primary"
          class="btn-up"
          dark
          fab
          @click="goTop()"
        >
          <v-icon>
            {{ mdiArrowUpBold }}
          </v-icon>
        </v-btn>
      </v-row>

      <!-- MODALS -->
      <ModalUpload
        v-if="$store.state.modal_upload"
        class="mb-6"
        :content_type="content_type"
        :categories="content_type ? professionalCategories : categories"
        :categories-array="categoriesArrayId"
        @getCategories="getCatgContentType"
        @newFile="newFile()"
        @closingModal="$store.commit('showUploadModal', false)"
      />
      <ModalDetails
        v-if="modals.content"
        :actions="true"
        class="mb-6"
        :modals="modals"
        @closingModal="modalClose"
        @openEdit="openEdit"
        @openZoom="openZoom"
      />
      <ModalEdit
        v-if="$store.state.modal_edit"
        class="mb-6"
        :content_type="content_type"
        :categories="content_type ? professionalCategories : categories"
        :categories-array="categoriesArrayId"
        :tags-full="tags"
        :modals="modals"
        @closingModal="$store.commit('showEditModal', false)"
        @getCategories="getCatgContentType"
      />
      <ModalZoom
        v-if="modals.zoom"
        class="mb-6"
        :modals="modals"
        @closingModal="closeZoom"
      />

      <!-- <Agreements class="mb-6" /> -->
      <ModalCustomCategories
        v-if="$store.state.customCategories"
        :content_type="content_type"
        :categories="content_type ? professionalCategories_full : categories_full"
        :categories-array="categoriesArray"
        @getCategories="getCatgContentType"
      />
      <!-- ###### -->
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import {
  mdiChevronDown, mdiCached, mdiCloudUpload, mdiArrowUpBold, mdiBookOpenVariant, mdiSquareEditOutline, mdiTrashCan, mdiShareVariantOutline, mdiAccountTie, mdiAccount, mdiAccountMultiple, mdiListStatus, mdiMagnify, mdiClose, mdiSortAscending, mdiSortDescending,
} from '@mdi/js'
import ModalUpload from '@/components/modals/ModalUpload.vue'
import ModalDetails from '@/components/modals/ModalDetails.vue'
import ModalEdit from '@/components/modals/ModalEdit.vue'
import ModalZoom from '@/components/modals/ModalZoom.vue'
import ModalCustomCategories from '@/components/modals/ModalCustomCategories.vue'

// import Agreements from '@/components/Agreements.vue';

export default {
  name: 'Grid',
  directives: {
  },
  components: {
    ModalCustomCategories,
    ModalUpload,
    ModalEdit,
    ModalDetails,
    ModalZoom,
  },
  data: () => ({
    /* Icons */
    mdiChevronDown,
    mdiCloudUpload,
    mdiAccountTie,
    mdiAccount,
    mdiAccountMultiple,
    mdiListStatus,
    mdiCached,
    mdiArrowUpBold,
    mdiSortAscending,
    mdiSortDescending,
    mdiBookOpenVariant,
    mdiSquareEditOutline,
    mdiTrashCan,
    mdiShareVariantOutline,
    mdiMagnify,
    mdiClose,

    /* ---- */
    deletingFile: [],
    result: false,
    activeYear: null,
    activeMonth: null,
    loading4: false,
    user: {
      id: 0,
    },
    active: 1,
    logged: true,
    pagination: 1,
    qtdPages: 1,
    limitItems: 10,
    images: [],
    orientation: 'vertical',
    modals: {
      content: false,
      edit: false,
      upload: false,
      zoom: false,
      title: '',
      description: '',
      gallery: true,
      file: {
        created_at: '',
        url: '',
        name: '',
      },
    },
    endpoint: process.env.VUE_APP_ROOT_API,
    fileUploaded: null,
    categories: [],
    categories_full: [],
    categoriesArray: [],
    categoriesArrayId: [],
    professionalCategories: [],
    professionalCategories_full: [],
    file: {
      url: '',
      related_files: [],
    },
    files: [],
    categorySelected: '',
    cmdCategory: [],
    loading: true,
    uploadPercentage: 0,
    resultUpload: false,
    networks: [
      {
        network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f share-icon', color: '#1877f2',
      },
    ],
    tags: [],
    relatedFiles: [],
    content_type: 0,
    counterFlow: 0,

    /* Categories */
    message: {
      status: false,
      text: '',
    },
    timer: null,
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',	'July',	'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    timeline: [],
    timeout: null,
    failedImages: {},
    editingDateIndex: null,
    editDate: {
      year: null,
      month: null,
      day: null,
    },
    savingDate: false,
    orderBy: 'entry_date',
    orderDir: 'desc',
    dateFilter: '',
    dateInputVisible: false,
  }),
  watch: {
  },
  mounted() {
    this.checkLogin()
  },
  methods: {
    initializeSharedContentType() {
      const storedType = Number.parseInt(localStorage.getItem('sb-shared-content-type'), 10)
      if (Number.isInteger(storedType) && [0, 1, -1].includes(storedType)) {
        this.content_type = storedType
      }
      this.$store.commit('setContentType', this.content_type)
    },
    persistSharedContentType() {
      localStorage.setItem('sb-shared-content-type', String(this.content_type))
    },
    findRootCategoryId(categories, targetId) {
      for (const category of categories) {
        if (Number(category.id) === Number(targetId)) return Number(category.id)
        if (category.children && category.children.length) {
          const nestedMatch = this.findRootCategoryId(category.children, targetId)
          if (nestedMatch !== null) return Number(category.id)
        }
      }

      return null
    },
    getSelectedRootCategoryId() {
      if (!this.categorySelected) return null
      const selectedId = Number(this.categorySelected)
      const personalMatch = this.findRootCategoryId(this.categories, selectedId)
      if (personalMatch !== null) return personalMatch

      return this.findRootCategoryId(this.professionalCategories, selectedId)
    },
    rootCategoryClasses(categoryId) {
      return {
        'root-category-active': Number(categoryId) === this.getSelectedRootCategoryId(),
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    getVideoType(filePath) {
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    goTop() {
      // window.scrollTo(0,0);
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${this.months[parseInt(month, 10) - 1]} ${year}`
    },
    startEditDate(file, index) {
      const [year, month, day] = file.updated_at.split('T')[0].split('-')
      this.editDate = {
        year: parseInt(year, 10),
        month: parseInt(month, 10),
        day: parseInt(day, 10),
      }
      this.editingDateIndex = index
    },
    onDateFocusOut(event, file) {
      const wrapper = event.currentTarget
      setTimeout(() => {
        if (wrapper.contains(document.activeElement)) return
        this.saveEditedDate(file)
      }, 0)
    },
    async saveEditedDate(file) {
      if (this.savingDate) return
      const y = parseInt(this.editDate.year, 10)
      let m = parseInt(this.editDate.month, 10)
      let d = parseInt(this.editDate.day, 10)
      if (!Number.isInteger(y) || y < 1900 || y > 2999
        || !Number.isInteger(m) || m < 1 || m > 12
        || !Number.isInteger(d) || d < 1 || d > 31) {
        this.editingDateIndex = null
        return
      }
      // clamp day to month length
      const maxDay = new Date(y, m, 0).getDate()
      if (d > maxDay) d = maxDay
      const newDate = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
      const currentDate = file.updated_at.split('T')[0]
      if (newDate === currentDate) {
        this.editingDateIndex = null
        return
      }

      this.savingDate = true
      try {
        await axios.post(`${this.endpoint}/updateFileDate`, {
          date: newDate,
          file_id: file.id,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })
        // Reflect change locally (preserve time portion if present)
        const timePart = file.updated_at.includes('T')
          ? file.updated_at.split('T')[1]
          : ''
        this.$set(file, 'updated_at', timePart ? `${newDate}T${timePart}` : newDate)
      } catch (err) {
        console.error('Failed to save date:', err)
      }
      this.savingDate = false
      this.editingDateIndex = null
    },
    onSortChange() {
      this.files = []
      this.deletingFile = []
      this.pagination = 1
      this.timeline = []
      this.getFiles()
    },
    toggleDateInput() {
      this.dateInputVisible = !this.dateInputVisible
      if (this.dateInputVisible) {
        this.$nextTick(() => this.$refs.dateInput && this.$refs.dateInput.focus())
      } else {
        this.clearDateFilter()
      }
    },
    closeDateInput() {
      this.dateInputVisible = false
      this.clearDateFilter()
    },
    onDateInputBlur() {
      if (!this.dateFilter) {
        this.dateInputVisible = false
        return
      }
      this.onDateFilterChange()
    },
    onDateMaskInput(e) {
      let v = e.target.value.replace(/[^0-9]/g, '')
      if (v.length > 4) v = v.slice(0, 4) + '-' + v.slice(4)
      if (v.length > 7) v = v.slice(0, 7) + '-' + v.slice(7)
      if (v.length > 10) v = v.slice(0, 10)
      this.dateFilter = v
    },
    onDateFilterChange() {
      this.files = []
      this.deletingFile = []
      this.pagination = 1
      this.timeline = []
      this.getFiles()
    },
    clearDateFilter() {
      this.dateFilter = ''
      this.files = []
      this.deletingFile = []
      this.pagination = 1
      this.timeline = []
      this.getFiles()
    },
    getCatgContentType(val) {
      this.content_type = val
      this.$store.commit('setContentType', val)
      this.persistSharedContentType()
      this.getCategories()
    },
    checkContentType(val) {
      this.content_type = val
      this.$store.commit('setContentType', val)
      this.persistSharedContentType()
      this.searchCategory(-1, 1)
    },
    checkLogin() {
      this.$store.commit('setLogin', true)
      this.active = true
      this.logged = true
      this.$store.commit('setUploadBiographies', true)
      this.initializeSharedContentType()
      this.searchCategory(-1, 1)
    },
    callPagination(page) {
      this.searchCategory(this.categorySelected, page)
    },
    openEdit(evt) {
      const self = this
      this.modals.content = false
      if (evt.file) {
        self.$set(self.modals, 'file', evt.file)
      } else {
        self.$set(self.modals, 'file', evt)
      }
      this.$store.commit('showEditModal', true)
    },
    openZoom(zoomPayload = {}) {
      const zoomIndex = Number.isInteger(zoomPayload.index) ? zoomPayload.index : 0
      const fallbackUrl = this.modals.file.related_files && this.modals.file.related_files.length
        ? (this.modals.file.related_files[zoomIndex] || this.modals.file.related_files[0])
        : ''
      const rotatePosition = this.modals.file.rotate_position && this.modals.file.rotate_position.length
        ? (this.modals.file.rotate_position[zoomIndex] || this.modals.file.rotate_position[0])
        : 0

      this.$set(this.modals.file, 'zoomIndex', zoomIndex)
      this.$set(this.modals.file, 'zoomUrl', zoomPayload.url || fallbackUrl)
      this.$set(this.modals.file, 'zoomVariation', zoomPayload.variation || null)
      this.$set(this.modals.file, 'zoomRotatePosition', rotatePosition)
      this.modals.zoom = true
    },
    closeZoom() {
      this.modals.zoom = false
    },
    modalClose(search) {
      this.$store.commit('showEditModal', false)
      this.modals.content = false
      this.fbConverting = false
      this.modals.upload = false
      this.modals.zoom = false
      if (search) {
        this.searchCategory(-1, 1)
      }
    },
    newFile() {
      const self = this
      self.modalClose(true)
      setTimeout(() => {
        self.modals.upload = true
      }, 200)
    },
    subString(value) {
      if (value !== undefined) {
        return `${value.substring(0, 540)}...`
      }

      return value
    },
    searchCategory(value, page) {
      this.categorySelected = value !== -1 ? value : ''
      this.files = []
      this.getCategories()
      this.pagination = page
      this.timeline = []
    },
    geoCodeReverse() {
      const self = this
      const geocoder = new google.maps.Geocoder()

      self.maps.currentLocation = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng(),
      }

      geocoder.geocode({ location: self.maps.searchAddressInput }, (results, status) => {
        if (status === 'OK') {
          console.log(results)
        }
      })
    },
    getCategories() {
      const self = this
      axios.get(`${self.endpoint}/getCategories`, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(response => {
        self.categories = []
        self.categories_full = []
        self.categoriesArray = []
        self.categoriesArrayId = []
        self.professionalCategories = []
        self.professionalCategories_full = []
        self.active_menu_categories = response.data.active_menu_categories
        response.data.content.forEach(value => {
          if (value.type) {
            if (!value.content_type) {
              if (value.active) {
                self.categories.push(value)
                if (self.content_type === 0) {
                  self.categoriesArrayId.push(value.id)
                }
              }
              self.categories_full.push(value)
              self.categoriesArray.push(value.name)
            } else {
              if (value.active) {
                self.professionalCategories.push(value)
                if (self.content_type === 1) {
                  self.categoriesArrayId.push(value.id)
                }
              }
              self.professionalCategories_full.push(value)
              self.categoriesArray.push(value.name)
            }
          }
        })
        this.getFiles()
        self.tags = response.data.tags
      })
    },
    selectTimelineDate(year, month) {
      this.dateFilter = ''
      this.pagination = 1
      this.files = []
      this.getFiles(year, month)
    },
    getFiles(year, month) {
      this.$set(this, 'activeYear', year)
      this.$set(this, 'activeMonth', month)
      const dateParts = this.dateFilter ? this.dateFilter.trim().split('-') : []
      const filterYear = dateParts[0] || year
      const filterMonth = dateParts[1] || month
      const filterDay = dateParts[2] || undefined
      axios.get(`${this.endpoint}/getFiles?content_type=${this.content_type >= 0 ? this.content_type : ''}${filterYear ? `&year=${filterYear}` : ''}${filterMonth ? `&month=${filterMonth}` : ''}${filterDay ? `&day=${filterDay}` : ''}&active_menu_categories=${this.active_menu_categories}&category=${this.categorySelected}&order_field=${this.orderBy}&order=${this.orderDir}&limit=${(Math.abs((this.pagination - 1)) * this.limitItems)},${(this.limitItems)}`, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(response => {
        this.loading = false
        this.qtdPages = Math.ceil(response.data.total_files / this.limitItems)
        const lastFile = response.data.content[response.data.content.length - 1]
        if (lastFile) localStorage.setItem('last_location', lastFile.location)

        // this.timeline = [];
        if (year) {
          this.files = []
          this.deletingFile = []
        }

        response.data.content.forEach(value => {
          this.deletingFile.push(false)
          const yearC = value.updated_at.split('T')[0].split('-')[0]
          const monthC = value.updated_at.split('T')[0].split('-')[1]

          if (this.categorySelected) {
            if (this.timeline[yearC]) {
              if (!this.timeline[yearC].includes(monthC)) {
                this.timeline[yearC].push(monthC)
              }
            } else {
              this.timeline[yearC] = []
              this.timeline[yearC].push(monthC)
            }
          } else {
            response.data.filter_dates.forEach(valueFilter => {
              const yearF = valueFilter.split('-')[0]
              const monthF = valueFilter.split('-')[1]
              if (this.timeline[yearF]) {
                if (!this.timeline[yearF].includes(monthF)) {
                  this.timeline[yearF].push(monthF)
                }
              } else {
                this.timeline[yearF] = []
                this.timeline[yearF].push(monthF)
              }
            })
          }

          if (value.related_files) {
            value.related_files = value.related_files
          } else {
            value.related_files = []
          }
          if (value.rotate_position) {
            value.rotate_position = value.rotate_position.split(', ')
          } else {
            value.rotate_position = []
          }
          this.files.push(value)
        })
        this.loader = false
      })
        .catch(() => {
        /* ERROR */
          this.loader = false
        })
    },
    getNextPage() {
      this.loader = 'loading4'

      // window.onscroll = () => {
      //   let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      //   if (bottomOfWindow) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.pagination++
        this.getFiles()
      }, 300)
    },
    showModal(evt) {
      if (evt.file) {
        this.$set(this.modals, 'file', evt.file)
      } else {
        this.$set(this.modals, 'file', evt)
      }
      const currentFile = evt.file || evt
      this.$set(this.modals.file, 'zoomIndex', 0)
      this.$set(this.modals.file, 'zoomUrl', currentFile.related_files && currentFile.related_files.length ? currentFile.related_files[0] : '')
      this.$set(this.modals.file, 'zoomVariation', null)
      this.fbcounter = 0
      this.facebookImgUrl = ''
      this.modals.content = true
    },
    showDeleteBtns(status, index) {
      this.$set(this.deletingFile, index, status)
    },
    submitDelete(id) {
      const self = this
      self.loading = true

      console.log(id)

      axios.post(`${self.endpoint}/deleteFileInfos`, {
        file_id: id,
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        self.loading = false
        self.result = true
        this.deletingFile = []
        this.getFiles()
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper-menu {
  flex: 1;
  position: relative;
  .inner-wrapper-menu {
    text-align: center;
  }
  .v-btn {
    margin-bottom: 20px;
  }

  .v-btn:not(:last-child) {
    margin-right: 10px;
  }
}

.v-window.v-item-group.theme--dark.v-carousel img {
  width: 100%;
  height: auto;
  padding: 17px;
}

.date-anchor {
  position: absolute;
  top: -15%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  min-width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.date-item {
  display: block;
  position: static;
  z-index: 1;
  text-align: center;
  white-space: nowrap;
}

.date-item--editable {
  cursor: pointer;
  padding: 6px 10px;

  &:hover {
    text-decoration: underline;
  }
}

.date-edit-wrapper {
  position: static;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: #fff;
  padding: 2px 4px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}

.date-edit-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 13px;
  background: #fff;
  color: #000;

  &:focus {
    outline: none;
    border-color: #9155fd;
  }
}

.date-edit-month { width: 70px; }
.date-edit-day { width: 45px; }
.date-edit-year { width: 65px; }

.root-category-active {
  background-color: #9155fd !important;
  border-color: #9155fd !important;
  color: #fff !important;
}

.v-timeline {
  border-top: 1px solid #ccc;
  &::before {
    display: none !important;
  }
}

.v-timeline-item {
  position: relative;
  padding: 80px 0 60px;
  border-bottom: 1px solid #ccc;

  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  &:nth-child(odd) {
    .box-slider {
      .v-card:before,
      .v-card:after {
        transform: rotate(180deg) !important;
        right: -10px !important;
        left: initial !important;
      }
    }
  }
  &:nth-child(even) {
    .box-slider {
      .v-card:before,
      .v-card:after {
        transform: rotate(0deg) !important;
        right: initial !important;
        left: -10px !important;
      }
    }
  }
}

.wrapper-text {
  text-align: left;
}

.wrapper-icons {
  width: 1161px;
  position: absolute;
  top: -50px;
  left: 0;
  z-index: 1;

  .v-icon {
    padding: 0 5px;
    cursor: pointer;
  }
}

@media (min-width: 1264px) {
  .v-timeline-item__body .v-card,
  .v-timeline-item__opposite .box-slider .v-card {
    height: 351px !important;
    min-height: 351px !important;
  }
}

@media (min-width: 1904px) {
  .v-timeline-item__body .v-card,
  .v-timeline-item__opposite .box-slider .v-card {
    height: 415px !important;
    min-height: 415px !important;
  }
  .wrapper-icons {
    width: 1370px;
  }
}

.v-avatar-group {
  position: absolute;
  top: 25px;
  right: 5%;
  display: none;
}

.v-avatar-group>:not(:first-child) {
  margin-left: -0.8rem;
}

.box-slider {
  .biography-media {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  img {
    width: 100% !important;
    height: 100% !important;
    display: block;
    max-width: 100%;
    max-height: 100%;
    padding: 17px !important;
    cursor: pointer;
    border-radius: 8px;
    object-fit: contain;
  }
}

@media(max-width: 940px) {
  .v-timeline-item__divider {
    display: none !important;
  }

  .box-slider {
    img {
      position: static;
    }
  }
}

.list-menu {
  margin: 0 0px !important;
  padding: 0 !important;
  justify-content: center !important;
  display: flex !important;
  li {
    text-align: left;
    list-style: none;
    cursor: pointer;
    position: relative;
    margin: 10px 0;
    ul {
      display: none;
      position: absolute;
      left: 0;
      width: auto;
      max-width: 300px;
      background: #fff;
      box-shadow: 0 4px 8px -4px rgb(94 86 105 / 42%);
      padding: 0;
      border-radius: 6px;
      top: 70%;
      z-index: 5;

      color:rgba(94, 86, 105, 0.87);
      text-transform: uppercase;
      font-size: 0.875rem;
      font-family: Inter, sans-serif;
      font-weight: 500;

      li {
        padding: 0 20px 0 15px;
        display: block;
        min-width: 150px;
        span {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .arrow-icon {
        transform: rotate(-90deg);
        position: absolute;
        right: -2px;
      }

      ul {
        left: 100%;
        top: -10px;
      }
    }
    &:hover {
      text-decoration: underline;
      > ul {
        display: block;
      }
    }
  }
  > li {
    float: left;
    margin: 0;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.wrapper-content {
  position: relative;
}

.sort-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;

  .v-btn-toggle { flex-shrink: 0; }
  .v-btn { min-width: 40px !important; }

  @media (max-width: 599px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto auto;
    gap: 8px 4px;
    .sort-label { grid-column: 1 / -1; text-align: left; }
    .sort-field { min-width: 0; }
    .sort-field .v-btn {
      flex: 1 1 0;
      min-width: 0 !important;
      padding: 0 4px;
      font-size: 10px;
      letter-spacing: 0;
    }
    .sort-direction .v-btn { min-width: 28px !important; padding: 0 4px; }
    .date-menu-button { min-width: 52px !important; padding: 0 4px; font-size: 10px; letter-spacing: 0; }
    .date-menu-button .v-icon { margin-left: 2px; margin-right: 0; }
    .date-filter-input-wrapper { position: relative; }
    .date-filter-field { position: absolute; right: 0; top: 32px; z-index: 6; background: var(--v-background-base, white); }
  }

  .sort-label {
    white-space: nowrap;
    font-size: 13px;
    color: rgba(94, 86, 105, 0.68);
    font-weight: 500;
  }
}

.date-filter-input-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;

  .date-filter-lupe {
    cursor: pointer;
    color: rgba(94, 86, 105, 0.5);
    font-size: 22px !important;
    transition: color 0.2s;

    &:hover {
      color: #9155fd;
    }
  }

  .date-filter-field {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 2px 8px;
    gap: 4px;
    transition: border-color 0.2s;
    overflow: hidden;

    &:focus-within {
      border-color: #9155fd;
    }
  }

  .date-filter-input {
    border: none;
    outline: none;
    font-size: 13px;
    width: 90px;
    background: transparent;
    color: rgba(94, 86, 105, 0.87);
    font-family: monospace;

    &::placeholder {
      color: rgba(94, 86, 105, 0.3);
    }

    &.date-filter-input--active {
      color: #9155fd;
      font-weight: 500;
    }
  }

  .date-filter-clear {
    cursor: pointer;
    color: rgba(94, 86, 105, 0.4);

    &:hover {
      color: #9155fd;
    }
  }
}

.date-filter-slide-enter-active,
.date-filter-slide-leave-active {
  transition: all 0.2s ease;
  max-width: 160px;
  opacity: 1;
}

.date-filter-slide-enter,
.date-filter-slide-leave-to {
  max-width: 0;
  opacity: 0;
}

.date-filter-active-label {
  font-size: 12px;
  color: #9155fd;
  font-weight: 500;
  margin-right: 8px;
}

/* Component */
.lst-timeline  {
  position: fixed;
  top: 335px;
  right: calc(((100vw - 1392px) - 250px) / 2);
  z-index: 5;
  margin: 0;
  overflow: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 815px);

  > li {
    list-style: none;
    width: 100px;
    padding: 10px 0 10px 20px;
    margin: 0;
    text-align: center;
    font-size: 14px;

    .v-icon {
      transform: scale(0.8) translate(-4px, -2px)  rotate(0deg);
    }

    &:first-child {
      padding-top: 0;
    }

    a {
      transition: all 0.2s ease;
      position: relative;
      color: rgba(94, 86, 105, 0.68);
      text-decoration: none;
      font-weight: 500;
      &:hover {
        padding-left: 15px;
        color: #9155fd;
      }
      &.active {
        color: #9155fd;
        font-weight: bold;
        .v-icon {
          transform: scale(0.8) translate(-4px, -2px) rotate(180deg);
          color: #9155fd;
        }
      }
    }

    ul {
      margin: 0;
      padding-left: 10px;
      transition: all 0.3s ease-out;
      height: 0;
      overflow: hidden;

      &.active {
        height: auto;
        margin: 5px 0;
        // a {
        //   color: #9155fd;
        // }
      }
    }

    li {
      list-style: none;
      padding: 0;
    }
  }
}

.show-all-years {
  position: fixed;
  top: 285px;
  right: calc(((100vw - 1392px) - 250px) / 2);
  margin: 0;
  width: 100px;
  text-align: center;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  color:rgba(94, 86, 105, 0.68);
  text-decoration: none;
  z-index: 2;
  &:hover {
    color: #9155fd;
  }
}

.pagination {
  span {
    display: block;
    text-align: center;
    margin-bottom: 20px;
  }
}

.btn-up {
  position: absolute;
  right: 11px;
  bottom: 0px;
}
</style>

<style lang="scss">
.my-biography .v-timeline-item__divider {
  overflow: visible;

  .v-timeline-item__dot,
  .v-timeline-item__inner-dot {
    pointer-events: none;
  }

  .date-anchor,
  .date-item,
  .wrapper-icons,
  .date-edit-wrapper,
  .date-edit-wrapper * {
    pointer-events: all;
  }
}

@media (min-width: 1264px) {
  .my-biography .v-timeline-item {
    .v-timeline-item__body > .v-card,
    .v-timeline-item__opposite > .box-slider > .v-card {
      height: 351px !important;
      min-height: 351px !important;
      max-height: 351px !important;
      overflow: hidden;
    }
  }
}

@media (min-width: 1904px) {
  .my-biography .v-timeline-item {
    .v-timeline-item__body > .v-card,
    .v-timeline-item__opposite > .box-slider > .v-card {
      height: 415px !important;
      min-height: 415px !important;
      max-height: 415px !important;
      overflow: hidden;
    }
  }
}
</style>
